"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _types = require("./types");

var _SankeyUtils = require("./SankeyUtils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SankeyNodeEditionPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  selected_node: _propTypes.default.shape(_types.SankeyNodePropTypes).isRequired,
  radio_selected: _propTypes.default.string.isRequired,
  getValueIndex: _propTypes.default.func.isRequired
};

var SankeyNodeEdition = function SankeyNodeEdition(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      selected_node = _ref.selected_node,
      radio_selected = _ref.radio_selected,
      getValueIndex = _ref.getValueIndex,
      children = _ref.children;
  var tags_catalog = data.tags_catalog;
  var tags_visible = Object.keys(tags_catalog).length > 0;

  var _useState = (0, _react.useState)(tags_visible ? Object.keys(tags_catalog)[0] : ''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tags_group_key = _useState2[0],
      set_tags_group_key = _useState2[1];

  var node = selected_node;

  if (node === undefined) {
    node = (0, _SankeyUtils.default_node)();
  }

  var outline_Fav_Button = function outline_Fav_Button(tag_key) {
    if (node.colorFavoriteTags != undefined && node.colorFavoriteTags[tags_group_key] != undefined && node.colorFavoriteTags[tags_group_key].tag_associated === tag_key) {
      return 'warning';
    } else {
      return 'outline-warning';
    }
  };

  var node_tag = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "tags",
    title: "Tags"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Tag Groupe:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    onChange: function onChange(evt) {
      return set_tags_group_key(evt.target.value);
    }
  }, Object.entries(tags_catalog).map(function (tags_group, i) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: tags_group[0],
      selected: tags_group_key === tags_group[0]
    }, tags_group[1].group_name);
  })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    striped: true,
    bordered: true,
    hover: true
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Nom"), /*#__PURE__*/_react.default.createElement("th", null, "Appartenance"), /*#__PURE__*/_react.default.createElement("th", null, "Favoris"))), /*#__PURE__*/_react.default.createElement("tbody", null, tags_visible && tags_group_key != '' ? Object.entries(tags_catalog[tags_group_key].tags).map(function (tags) {
    var node_tags = node.tags[tags_group_key];
    var checked = node_tags ? node_tags.includes(tags[0]) : false;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: tags[0]
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, tags[1].name)), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
      name: 'element_visible' + tags[0],
      checked: checked,
      id: tags[0],
      type: "checkbox",
      onChange: function onChange(evt) {
        var new_nb_element = evt.target;
        var tag_key = new_nb_element.id;
        var visible = new_nb_element.checked;

        if (visible) {
          if (!node.tags[tags_group_key]) {
            node.tags[tags_group_key] = [];
          }

          node.tags[tags_group_key].push(tag_key);
        } else {
          node.tags[tags_group_key].splice(node.tags[tags_group_key].indexOf(tag_key));
        }

        set_data((0, _objectSpread2.default)({}, data));
      }
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      size: "sm",
      variant: outline_Fav_Button(tags[0]),
      onClick: function onClick() {
        console.log(node.tag_favorite);
        console.log(tags_group_key);
        console.log(tags[0]);
        node.tag_favorite['tagGroup'] = tags_group_key;
        node.tag_favorite['tagElement'] = tags[0]; // Modification
        // je ne pense pas qu'il soit necessaire ici de donner la couleur
        // le tagGroup et le tag est suffisant
        // de plus je ne sais pas si il faut un favori par groupTag sinon ne sait pas quoi prendre
        //const newFavColor = {
        //  tagGroup_associated : tags_group_key,
        //  tag_associated: tags[0],
        //  color: tags_catalog[tags_group_key].tags[tags[0]].color
        //}
        // if (node.colorFavoriteTags === undefined || node.colorFavoriteTags === null) {
        //   node.colorFavoriteTags = {}
        // }
        // if (Object.keys(node.colorFavoriteTags).includes(tags_group_key)) {
        //   delete node.colorFavoriteTags[tags_group_key]
        // } else {
        //   node.colorFavoriteTags[tags_group_key] = newFavColor
        // }
        //node.colorFavoriteTags= newFavColor

        set_data((0, _objectSpread2.default)({}, data));
      }
    }, "\u2605")));
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)))));

  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    defaultActiveKey: "nodes_desc",
    id: "settings-layout"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "nodes_desc",
    title: "Description"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Visibilit\xE9")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    inline: true,
    type: "switch",
    checked: node.shape_visible,
    onChange: function onChange(evt) {
      node.shape_visible = evt.target.checked;
      node.node_visible = node.label_visible || node.shape_visible;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Couleur")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 3
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "color",
    disabled: radio_selected !== 'local',
    value: node.color,
    onChange: function onChange(evt) {
      node.color = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Shape")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "product",
    type: "radio",
    label: "Circle",
    checked: node.type === 'product',
    onChange: function onChange(evt) {
      node.type = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "sector",
    type: "radio",
    label: "Rectangle",
    checked: node.type === 'sector',
    onChange: function onChange(evt) {
      node.type = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "label_desc",
    title: "Labels"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Label visible",
    checked: node.label_visible,
    onChange: function onChange(evt) {
      node.label_visible = evt.target.checked;
      node.node_visible = node.label_visible || node.shape_visible;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), Object.keys(tags_catalog).length > 0 ? node_tag : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "node_tooltip",
    title: "Tooltip"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, {
    column: true,
    sm: 1
  }, "Tooltip:"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 11
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    as: "textarea",
    rows: 10,
    value: node.tooltip_text ? node.tooltip_text : '',
    onChange: function onChange(evt) {
      node.tooltip_text = evt.target.value.split('\n').join('\\n');
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), children)));
};

var _default = SankeyNodeEdition;
exports.default = _default;